import request from '@/utils/request'
export function getColByRegionCode(name, regionCode) {
  return request({
    url: `/api/staging/${name}`,
    nonstandard: true,
    method: 'get',
    params: {
      regionCode,
    },
  })
}
